import React from "react";
function Search(props) {
  const handleSubmit = (event) => {
    event.preventDefault();
    props.search(props.term);
  };

  return (
    <div className="searchBar" id="searchAPI">
      <form onSubmit={handleSubmit}>
        <input
          id="term"
          className="search-field"
          type="text"
          value={props.term}
          placeholder="search here...."
          onChange={(e) => props.setTerm(e.target.value)}
        ></input>
        <button type="submit">
          <img
            alt="search icon"
            className="icon"
            src="icons/search-white-icon.png"
          />
        </button>
      </form>
    </div>
  );
}

export default Search;